import React, { useContext, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
// import p from "@mui/material/p";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import { Button } from "@mui/material";
import { Chip, Tooltip } from "@mui/material";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import Typography from "@material-ui/core/Typography";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

function PostCard({ post, curUser }) {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const { user, setUser } = useContext(UserContext);

  const upvote = () => {
    axios
      .put(
        "api/invitation/upvote",
        {
          invitationId: post._id,
        },
        {
          headers: {
            "x-auth-token": user,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const isCollaborator = (id) => {
    if (post.userId._id === id) {
      return true;
    }
    post.collaborators?.forEach((collaborator) => {
      if (collaborator._id === id) {
        return true;
      }
    });
    return false;
  };

  return (
    <>
      {/* loop from here  */}
      <div className="post">
        <div className="post_left">
          <img
            src={post.pic}
            alt="Project Image"
            className="post_img explore_img"
          />
        </div>

        <div className="post_right">
          <div className="header">
            <div>
              <p className="title_header">{post.title}</p>
            </div>

            <div className="post_id">
              <img
                alt="Profile Pic"
                src={post.userId.pic}
                className="pic_avatar"
              />
              <div>
                <p className="username">{post.userId.username}</p>
              </div>
            </div>

            <div>
              <p className="post_date">{post.updatedAt.split("T")[0]}</p>
            </div>
          </div>
          {/*closes header*/}

          <div className="post_body">
            <div className="collab">
              <Avatar
                alt="Profile Pic"
                src={post.userId.pic}
                className="pic_collab"
              />
              <Avatar
                alt="Profile Pic"
                src="https://res.cloudinary.com/tsec-hacks-2022/image/upload/v1646882144/Nishant_htlybc.jpg"
                className="pic_collab"
              />
              <Avatar
                alt="Profile Pic"
                src="https://res.cloudinary.com/tsec-hacks-2022/image/upload/v1646882143/IMG-20200302-WA0072_3_own75h.jpg"
                className="pic_collab"
              />
              <p className="collab_txt">
                {/* {post.accepted.length}  */}
                Collaborators involved
              </p>
            </div>

            <div>
              <p className="post_header">About</p>
              <p className="post_abt">{post.about}</p>
            </div>
          </div>

          <div className="post_body">
            <p className="post_header h_skill">Skills</p>
            <div>
              {post.tags.map((skill) => (
                <Chip component="a" label={skill.value} className="chips" />
              ))}
            </div>
          </div>

          <div className="action_btn">
            <CardActions disableSpacing>
              <Tooltip title="Upvote">
                <Typography className="upvote">
                  <IconButton
                    onClick={upvote}
                    className="upvote_btn"
                    aria-label="add to favorites"
                  >
                    <ArrowUpwardOutlinedIcon></ArrowUpwardOutlinedIcon>
                  </IconButton>

                  {post.upvote}
                </Typography>
              </Tooltip>

              {curUser && isCollaborator(curUser?._id) ? (
                <Button
                  href={`https://discussionmeet.pythonanywhere.com/${post._id}/${curUser.username}`}
                >
                  Video Chat
                </Button>
              ) : (
                ""
              )}

              {post.userId === curUser?._id ? (
                ""
              ) : (
                <Button className="request_btn" variant="contained">
                  Request Collaboration
                </Button>
              )}
            </CardActions>
          </div>
        </div>

        {/* <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <Tooltip title="Read More">
            <ExpandMoreIcon />
          </Tooltip>
        </ExpandMore>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
      
        </Collapse> */}
      </div>
      {/* loop till here */}
    </>
  );
}

export default PostCard;
